module.exports = __webpack_public_path__ + "img/tutorial_seven_fr.5f8e2bfb.png";